import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0,
        flexGrow: 0,
        minWidth: 0
    }
});
export default stylesheet;
